import React, { Component } from 'react'

import * as actions from "./actions";
import * as utils from "../utils";

import CommentForm from "../posts/components/comment-form";
import FeedPost from "../posts/components/feed-post";
import FetchingContent from "../common/components/fetching-content";
import HostMessageLink from "../common/components/host-message-link";
import RsvpToPerformActionLink from "../common/components/rsvp-to-perform-action-link";
import SimpleModal from "../common/components/simple-modal";
import { connect } from 'react-redux';

const ActivityFeed = React.createClass({
  componentWillMount() {
    if (this.props.state.activityfeed.hydratingFeed) {
      actions.hydrateFeedPosts();
    }
  },
  render() {
    const activityfeed = this.props.state.activityfeed;
    if (window.evite_event.options.event_option_disable_feed) {
      return (
        <div>
          { window.host_message &&
            <HostMessageLink />
          }
          <h3 className="feed-notice">The host has hidden activity</h3>
        </div>
      );
    }
    return (
      <div>
        <SinglePostModal
          post={activityfeed.objects[0]}
          singlePostOptions={activityfeed.singlePostOptions}
        />
        { window.host_message &&
          <HostMessageLink />
        }
        { utils.canComment() ?
          <div className="create-post simple-shadowbox">
            <CommentForm />
          </div>
        :
          <RsvpToPerformActionLink action="interact" />
        }
        { activityfeed.hydratingFeed ?
          <FetchingContent fetching="activity" />
        :
          <FeedList feedData={activityfeed} />
        }
      </div>
    );
  }
});

const SinglePostModal = React.createClass({
  componentWillUnmount() {
    if (this.props.singlePostOptions) {
      actions.setSinglePostModalVisible(false);
    }
  },
  render: function() {
    if (!this.props.singlePostOptions) {
      return null;
    }
    let modalContent;
    if (this.props.singlePostOptions.deleted) {
      modalContent = <DeletedPostModalContent />;
    } else {
      modalContent = <FeedPost post={this.props.post} />;
    }
    return (
      <SimpleModal
        isOpen={this.props.singlePostOptions.visible}
        onCloseClick={this.closeModal}
        modalId="single-post-modal"
        modalClassName="event-view single-post-modal"
      >
        {modalContent}
        <a href="#"
          className="return-to-feed"
          onClick={this.closeModal}
        >
          Close &amp; View Invitation
        </a>
      </SimpleModal>
    )
  },
  closeModal: function(e) {
    e.preventDefault();
    actions.setSinglePostModalVisible(false);
    if (history.pushState) {
      const newUrl = `${window.location.origin + window.location.pathname}?gid=${window.guest_id || ""}`;
      window.history.pushState({path:newUrl},'',newUrl);
    }
  }
});

function DeletedPostModalContent() {
  return (
    <div className="deleted-post-notification">
      <h3>
        Sorry, this content isn't available
      </h3>
      <p>
        This comment, photo, or reply for the link you followed has been deleted.
      </p>
      <p>
        <small>
          Why did I get this message?&nbsp;
          <a
            href="http://help.evite.com/customer/portal/articles/2568799-delete-comments"
            target="_blank"
          >
            Learn More.
          </a>
        </small>
      </p>
    </div>
  );
}

const FeedList = React.createClass( {
  render: function () {
    const { objects, more, cursor } = this.props.feedData;
    const isMobile = utils.isMobile();
    const isPremium = utils.isPremium();
    const hasRsvpd = utils.hasRsvpd();
    const showEmptyNotice = hasRsvpd && objects.length === 0;
    const post_nodes = objects.slice(0).reverse().map((post, i) => {
      return (
        <FeedListItem post={post} i={i} key={`feedlist-${post.id}`} />
      );
    });
    return (
      <div className="feed-list">
          { showEmptyNotice &&
            <EmptyFeedNotice />
          }
          { !isPremium && (
            isMobile ?
              <MobileFeedAd />
                 :
              <DesktopFeedAd />
            )
          }
        <div className="feed-list-item-group">
          {post_nodes}
        </div>
        { more &&
          <ShowMorePostsLink cursor={cursor} />
        }
      </div>
    )
  }
});

const DesktopFeedAd = React.createClass({
  shouldComponentUpdate: function() {
    // Don't re-render on state changes
    return false;
  },
  componentDidMount: function() {
    if (!window.sponsoredFeedAd) {
      window.setTimeout(function () {
        googletag.cmd.push(function () {
          window.sponsoredFeedAd = googletag.defineSlot(
              `${window.dfp_desktop_id}/${desktop_slot1() + desktop_slot2() + desktop_slot3()}`,
              [[420, 100]],
              "div-gpt-feed-sponsored-ad"
          )
              .setTargeting('strnativekey', '7927646b')
              .addService(googletag.pubads());
          googletag.display("div-gpt-feed-sponsored-ad");
        });
      }, 2000)
    }
  },
  render: function() {
    return (
      <div id="div-gpt-feed-sponsored-ad" className="gpt-ad"></div>
    )
  },
  componentWillUnmount: function () {
    // Ghostery removes googletag.destroySlots
    if (googletag.destroySlots !== undefined) {
      googletag.destroySlots([window.sponsoredFeedAd])
    }
    return false;
  }
});

const MobileFeedAd = React.createClass({
  shouldComponentUpdate: function() {
    // Don't re-render on state changes
    return false;
  },
  componentDidMount: function() {
    if (!window.sponsoredFeedAd) {
      window.setTimeout(function() {
        googletag.cmd.push(function () {
          window.sponsoredFeedAd = googletag.defineSlot(
              `${window.dfp_mobile_id}/${slot1()}${slot2()}`,
              [[320, 100]],
              "div-gpt-feed-sponsored-ad"
          )
              .setTargeting('loc', ['mobile-feed'])
              .setTargeting('strnativekey', 'XP2MkiFrYjwNoKkkJQML5sE1')
              .addService(googletag.pubads());
        });
      googletag.display("div-gpt-feed-sponsored-ad");
      }, 2000);
    }
  },
  render: function() {
    return <div id="div-gpt-feed-sponsored-ad" className="gpt-ad"></div>
  },
  componentWillUnmount: function () {
    // Ghostery removes googletag.destroySlots
    if (googletag.destroySlots !== undefined) {
      googletag.destroySlots([window.sponsoredFeedAd])
    }
    return false;
  }
});

function EmptyFeedNotice(props) {
  return (
    <div className="empty-feed-notice simple-shadowbox">
      There are no comments yet - be the first!
    </div>
  )
}

function FeedListItem(props) {
  const { post, i } = props;
  return (
    <FeedPost post={post} index={i}/>
  )
}

const ShowMorePostsLink = React.createClass({
  shouldComponentUpdate: function() {
    return false;
  },
  render: function() {
    return (
      <a onClick={this.handleShowMoreClick} className="button-primary show-more-link">
        Show More
      </a>
    )
  },
  handleShowMoreClick: function(e) {
    e.preventDefault();
    actions.getFeedPosts(this.props.cursor);
  }
});

function mapStateToProps(state) {
  return {
    state: {
      activityfeed: state.activityfeed
    }
  }
};

const connectedActivityFeed = connect(mapStateToProps)(ActivityFeed);

export default connectedActivityFeed;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/activity-feed/components.es6